var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5443_45692",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5443_45692",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACEUlEQVRo3tWaO26DQBRFqbwCVzErwHVWkZKaHZCGtGQViHVkBaFLhyWyAKdPa4M7mNxnDVE+BuP5D9KRrMS27rHxm/cYgkDBcXgLQpCAAlTgAxxBz6HHe/6/gj83DGwedy/JGiEyUIMBsBuh1+zAE1ibDL4BJTgJhJ6C3qsEG53BVyAHHWCEQoGRDjyDlerwEWjG4BoFRt7BVlX4GLR/w2sWIFoQiydn5/Ap6C+FNyDAeAV7ZEzsk6fww1R4QwJjtUpFTpt+LrxBgfGbiJeG306d8xYFxt9EtKRUNkvCWxAgmtkSy+s8c1iAyOdW2M4Dge7iis3bA+aBAFH+a8yot/FI4PSrAUSY7NbwlgWI7KfAzkOBegwfXltxHRUYzkMRgiQi4R0QIBISKDwWKEig8ligIoEPjwX2JHD0WOAQLGmbHRbopQQ+H+5t00udQg4IHKR+xA4I7KXKqAMCr1ILmQMChVQr4YBAItXMWQ4/gFCqnbYsUEsPNJYFMumR0mL4E1hLD/UWBUoll1Ushe/ARsmFLUsCubJLixbCN2C1ZDemdVCgBZHSy+sm22YQK9/gMLjipqL7Y7NbTIY++ZTp2uQzcM7HWrdZNVebSPtGt6ZFKr9aKlXdaqC4tyknV1hdN3tQR0htLa8UItWl5u9h7maPSwcNFjQd0YhHcyoN23TFgFeRnj+mv1X8Ocn3MCJ5fAEsMLq2IZ0UeAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM5);
export default __webpack_public_path__ + "static/media/m5.914920ac12649be105845c1ce75cad0d.svg";
export { ForwardRef as ReactComponent };